export enum VendorCategoryFilter
{
    ALL_VENDORS = 0,
    MY_VENDORS = 1,
    CATALOG_VENDORS = 2,
    FAVORITE_VENDORS = 3
}